var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727981",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 10C17.4999 9.77 17.4899 9.55 17.4699 9.32L19.3299 7.91C19.7299 7.61 19.8399 7.05 19.5899 6.61L17.7199 3.38C17.4699 2.94 16.9299 2.76 16.4699 2.96L14.3199 3.87C13.9499 3.61 13.5599 3.38 13.1499 3.19L12.8599 0.88C12.7999 0.38 12.3699 0 11.8699 0H8.13991C7.62991 0 7.19991 0.38 7.13991 0.88L6.84991 3.19C6.43991 3.38 6.04991 3.61 5.67991 3.87L3.52991 2.96C3.06991 2.76 2.52991 2.94 2.27991 3.38L0.409909 6.62C0.159909 7.06 0.269909 7.61 0.669909 7.92L2.52991 9.33C2.50991 9.55 2.49991 9.77 2.49991 10C2.49991 10.23 2.50991 10.45 2.52991 10.68L0.669909 12.09C0.269909 12.39 0.159909 12.95 0.409909 13.39L2.27991 16.62C2.52991 17.06 3.06991 17.24 3.52991 17.04L5.67991 16.13C6.04991 16.39 6.43991 16.62 6.84991 16.81L7.13991 19.12C7.19991 19.62 7.62991 20 8.12991 20H11.8599C12.3599 20 12.7899 19.62 12.8499 19.12L13.1399 16.81C13.5499 16.62 13.9399 16.39 14.3099 16.13L16.4599 17.04C16.9199 17.24 17.4599 17.06 17.7099 16.62L19.5799 13.39C19.8299 12.95 19.7199 12.4 19.3199 12.09L17.4599 10.68C17.4899 10.45 17.4999 10.23 17.4999 10ZM10.0399 13.5C8.10991 13.5 6.53991 11.93 6.53991 10C6.53991 8.07 8.10991 6.5 10.0399 6.5C11.9699 6.5 13.5399 8.07 13.5399 10C13.5399 11.93 11.9699 13.5 10.0399 13.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearIcon);
export default __webpack_public_path__ + "static/media/gearIcon.44296ca9.svg";
export { ForwardRef as ReactComponent };